import React, { useContext } from "react";
import SubscriptionStatusContext from "../context/SubscriptionStatusContext";
import { SubscriptionStatus } from "../lib/types";
import useSubscriptionStatus from "../hooks/useSubscriptionStatus";

const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useContext<SubscriptionStatus | null>(SubscriptionStatusContext);
  const subscription = useSubscriptionStatus();

  return (
    <SubscriptionStatusContext.Provider value={subscription}>
      {children}
    </SubscriptionStatusContext.Provider>
  );
};

export default SubscriptionProvider;
